import React from 'react'

import { connect } from 'react-redux'

import RatingsDashboard from '../../components/ratings/ratingsDashboard'
import RatingsTable from '../../components/ratings/ratingsTable'
import RatingsDetails from '../../components/ratings/ratingsDetails'
import * as actions from './actions'
import BackButton from '../../images/back-arrow.svg'
import './styles.css'
import { opdbGTM } from '../../utils/pulseUtils'
import phoneFill from '../../images/phoneFill.svg'
import moment from 'moment'
import { routePrefix } from '../../config'
import UnReviewedOrders from './UnReviewedOrders/UnReviewedOrders'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'



class RatingsReviewsContainer extends React.Component {

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.ratingsList && nextProps.ratingsList.length===0){
      return { ratingsList: nextProps.ratingsList}
    }
    if (
      prevState &&
      nextProps.ratingsList &&
      prevState.ratingsList &&
      nextProps.ratingsList.length > 0 &&
      prevState.ratingsList.length === 0
    ) {
      nextProps.getOperatorDashboardRatings({ paytm_operator_id: parseInt(nextProps.paytmOperatorId) });
      return { ratingsList: nextProps.ratingsList };
    }
    return null;
  }

  componentDidMount() {
    this.props.ratingInformationList({ pageNo: 1 }, false);
    document.title = 'Ratings Reviews';
    opdbGTM.tabClicked('od_ratings_reviews_tab_clicked');
  }
 
  changeView(){
    const {detailsView} =this.props;
    this.props.changeView({ detailsView: !detailsView});
  }



  render() {
    
    let {
      operatorDashboardRatings,
      detailsView,
      totalServiceCount,
      sourceCitiesV2,
      destCitiesV2,
      showAskForReviews
    } = this.props;
    const loggedInDate = localStorage.getItem('logged-in-data');
    let today = new Date();
    const diffInDays = loggedInDate ? moment.duration(moment(today, "YYYY-MM-DD").diff(moment(loggedInDate,"YYYY-MM-DD"))).asDays() : 0;
    const showNote = (diffInDays >= 0 && diffInDays <= 30)
    return (
      <>
      {! showAskForReviews ? 
      <div className="ratings">
        <div className={showNote ? "rating-head-with-container" : "ratings-header"}>
          <div className="col-xs-4">
            {detailsView && <span onClick={()=>this.changeView()}><img className="ratings-back-button" src={BackButton} /></span>}
            <span className="ratings-header-text">Ratings and Reviews</span>
            <br />
            <span className="ratings-updated-date hide" style={{ display: 'none' }}>Last Updates</span>
          </div>
          <Link to={routePrefix + '/ratings-reviews/askForReview'}>
          <button className="ratingsButton" onClick={()=> opdbGTM.askReview()}>
            <img src={phoneFill} alt=''/>
            Ask for Review
          </button>
          </Link>
        </div>
        {
          detailsView  ? <RatingsDetails detailsPayload={this.props.detailsPayload}/> :null
        }
        {!detailsView ?
          <div>
              <RatingsDashboard totalServices={totalServiceCount} operatorDashboardRatings={operatorDashboardRatings} />

              <RatingsTable
              filterRatingsList={this.props.filterRatingsList} 
              sortDataBy={this.props.sortDataBy}
              getRouteRatingsDetails={this.props.getRouteRatingsDetails} 
              sourceCityList={this.props.sourceCityList}
              destCityList={this.props.destCityList}
              busTypeList={this.props.busTypeList} 
              filteredServicesCollection={this.props.filteredServicesCollection}
              sorting={this.props.sorting}
              ratingInformationList={this.props.ratingInformationList}
              totalServiceCount={totalServiceCount}
              getV2Cities={this.props.getV2Cities}
              sourceCitiesV2={sourceCitiesV2}
              destCitiesV2={destCitiesV2}
            /> 
          </div>:null}
      </div>
      : null }
      </>
    )
  }
}

const mapStateToProps = store => ({
  ratingsList: store.ratingsReducer.ratingsList, 
  filteredServicesCollection: store.ratingsReducer.filteredServicesCollection,
  servicesCollectionList: store.ratingsReducer.servicesCollectionList,
  sourceCityList: store.ratingsReducer.sourceCityList, 
  destCityList: store.ratingsReducer.destCityList, 
  busTypeList: store.ratingsReducer.busTypeList, 
  paytmOperatorId: store.ratingsReducer.paytmOperatorId, 
  operatorDashboardRatings: store.ratingsReducer.operatorDashboardRatings,
  sorting: store.ratingsReducer.sorting,
  detailsView: store.ratingsReducer.detailsView,
  detailsPayload: store.ratingsReducer.detailsPayload,
  totalServiceCount: store.ratingsReducer.totalServiceCount,
  sourceCitiesV2: store.ratingsReducer.sourceCitiesV2,
  destCitiesV2: store.ratingsReducer.destCitiesV2,
  showAskForReviews: store.ratingsReducer.showAskForReviews, 
})

const mapDispatchToProps = dispatch => ({
  ratingInformationList: (query, isNewQuery) => dispatch(actions.ratingInformationList(query, isNewQuery)),
  filterRatingsList: (query, isNewQuery) => dispatch(actions.filterRatingsList(query, isNewQuery)), 
  getOperatorDashboardRatings: (query, isNewQuery) => dispatch(actions.getOperatorDashboardRatings(query, isNewQuery)), 
  sortDataBy: (query, isNewQuery) => dispatch(actions.sortDataBy(query, isNewQuery)),
  getRouteRatingsDetails: (query, isNewQuery) => dispatch(actions.getRouteRatingsDetails(query, isNewQuery)),
  changeView: (query, isNewQuery) => dispatch(actions.changeView(query, isNewQuery)),
  getV2Cities: (query, fieldType) => dispatch(actions.getV2Cities(query, fieldType)),
  toggleAskForReviews: (query) => dispatch(actions.toggleAskForReviews(query)),
})

RatingsReviewsContainer.propTypes = {}

export default connect(mapStateToProps, mapDispatchToProps)(RatingsReviewsContainer)
